import queryStirng from 'query-string';
import "./Room.scoped.scss";
import RoomChatting from "../components/Room/Chatting/RoomChatting";
import RoomHeader from "../components/Room/RoomHeader";
import Members from "../components/Room/Members";
import { RouteComponentProps } from "react-router-dom";
import { useEffect, useState } from "react";
import emitJoinRoom from "../connector/emits/joinRoom";
import { useRecoilState } from "recoil";
import roomState from "../atoms/room";
import emitGetUsers from "../connector/emits/getUsers";
import emitGetMessages from "../connector/emits/getMessages";
import participantsState from "../atoms/participants";
import emitGetUserDetails from "../connector/emits/getUserDetails";
import emitGetMyInfo from "../connector/emits/getMyInfo";
import roomDetailState from '../atoms/roomDetail';
import emitGetRoomDetail from '../connector/emits/getRoomDetail';
import moment from 'moment';
import Picks from '../components/Room/Picks';
import axios from 'axios';
import environment from '../environment';

interface MatchParams {
  id: string;
}

const Room: React.FunctionComponent<RouteComponentProps<MatchParams>> = (
  { match, location }
) => {
  const roomId = match.params.id;

  const [room] = useRecoilState(roomState);
  const [roomDetail] = useRecoilState(roomDetailState);
  const [participants] = useRecoilState(participantsState);

  const [selectedMembersTab, setSelectedMembersTab] = useState('members');

  const updateRemainNextRound = () => {
    axios.get(`${environment.SERVER_URL}/pick/api/current-round.php`)
      .then(({ data }) => {
        const nextRound = Number((data as { fullRound: string }).fullRound) + 1;
        window.document.getElementById('nextRound')!.innerHTML = `${nextRound}`;

        const remainSecond = Math.ceil((300000 - ((new Date()).getTime() + 25000) % 300000) / 1000);
        window.document.getElementById('remainNextRound')!.innerHTML =
          `${Math.floor(remainSecond / 60)}분 ${remainSecond % 60}초`;
      });
  };

  useEffect(() => {
    updateRemainNextRound();
    setInterval(updateRemainNextRound, 1000);
  });

  useEffect(() => {
    const query = queryStirng.parse(location.search);
    emitJoinRoom(roomId, (query.password ?? '') as string);
    emitGetMyInfo();
  }, [location.search, roomId]);

  useEffect(() => {
    emitGetRoomDetail(roomId);
    emitGetUsers(roomId);
    emitGetMessages(roomId);
  }, [room.isJoin, roomId]);

  useEffect(() => {
    emitGetUserDetails(participants.users);
  }, [participants.users]);

  const users = participants.users.filter((v, i, a) => a.indexOf(v) === i);

  const thumbnailUrlTailer = Math.floor(moment().unix() / 60);
  const thumbnailUrl = roomDetail.ownerDetail.hasThumbnail
      ? `/data/member_image/${roomDetail.owner.substring(0, 2)}/${roomDetail.owner}.gif?${thumbnailUrlTailer}`
      : '/img/profile.png';

  return (
    <>
      <div className="room">
        <RoomHeader 
          thumbnailUrl={thumbnailUrl}
          roomName={roomDetail.name}
          ownerNickname={roomDetail.ownerDetail.nickname}
          participants={users.length}
        />
        <div className="room__contents">
          <div className="room__chatting">
            <RoomChatting />
          </div>
          <div className="room__members">
            <div className="room__members-remain-next-round">
              <b id="remainNextRound">0분 00초</b> 후 <b id="nextRound">0</b> 회차 결과 발표
            </div>
            <div className="room__members-tab-select">
              <button
                className={`${selectedMembersTab === 'members' ? 'active' : ''}`}
                onClick={() => setSelectedMembersTab('members')}
              >
                접속자 목록
              </button>
              <button
                className={`${selectedMembersTab === 'picks' ? 'active' : ''}`}
                onClick={() => setSelectedMembersTab('picks')}
              >
                방장픽 목록
              </button>
            </div>
            {
              selectedMembersTab === 'members'
                ? (<Members />)
                : (<Picks />)
            }
          </div>
        </div>
      </div>
      <div className="popup-footer">
        Copyright ⓒ <strong style={{color: '#127ccb'}}>BLACKCHIP365</strong> All Rights Reserved.
      </div>
    </>
  );
}

export default Room;
